import { Col, Grid, Row } from "antd";
import { getMaxContainerHeight } from "./helpers";
import { useEffect, useState } from "react";
import { UserList, UsersCountCards } from "./components";

import { useRecoilState } from "recoil";
import { userDetailData2, userDetailPopup } from "store/atom";
import styles from "./styles.module.scss";

const { useBreakpoint } = Grid;

export const AnalyticsV2 = () => {
  const screens = useBreakpoint();
  const [maxHeight, setMaxHeight] = useState(0);
  const [showUserSubscDetailModal, setShowUserSubscDetailModal] =
    useRecoilState(userDetailPopup);
  const [userInfo, setUserInfo] = useRecoilState(userDetailData2);
  // const [userInfo, setUserInfo] = useRecoilState(userDetailData);

  useEffect(() => {
    function handleResize() {
      setMaxHeight(getMaxContainerHeight({ screens }));
    }

    const timeout = setTimeout(handleResize, 300); // Call it initially to set the height on mount

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", handleResize);
    };
  }, [screens]);

  // useEffect(() => {
  //   if (state?.from === "/user-history") {
  //     setShowUserSubscDetailModal(true);
  //   }
  // }, [state]);

  function handleCloseModal() {
    setShowUserSubscDetailModal(false);
    setUserInfo({
      username: null,
      userEmail: null,
      userId: null,
    });
  }

  return (
    <div className={styles.analyticsPageContainer}>
      <UsersCountCards />

      <Row id="user-list-row">
        <Col lg={24}>
          <UserList
            setShowUserSubscDetailModal={setShowUserSubscDetailModal}
            setUserInfo={setUserInfo}
            maxHeight={maxHeight}
            showUserSubscDetailModal={showUserSubscDetailModal}
            userInfo={userInfo}
            handleCloseModal={handleCloseModal}
          />
        </Col>
      </Row>
    </div>
  );
};
